import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { iconUrl } from '../rapport/rapportIcons';
import { AUTODIAG } from './autodiagChoiceTokens';

// Aperçu du parcours questionnaire : reconstruction stylisée de l'écran de
// choix du problème du Tally (tally.so/r/mZJlDo) — révision, pneu à plat,
// roue voilée, frein, transmission. Reconstruction HTML/CSS et non capture
// bitmap : aucun asset n'existe, une capture périmerait à la première modif
// du Tally, et le HTML reste net en HiDPI, léger et traduisible (cf. plan
// FIX-430, blocker B2). Décoratif — aria-hidden posé par le parent.
// Tout est en <span> : ce bloc vit DANS un <button> (contenu phrasé only).
//
// Icônes brand rendues en <img> (bi-ton préservé, cf. rapportIcons.js).
// Le sizing est scopé à Row > img — JAMAIS de règle `.card img` générique :
// une règle non scopée dans un media query a déjà gonflé l'icône chrono de
// 16 à 36px dans la maquette d'origine.

const ROWS = [
  { icon: 'OUTILS', labelKey: 'autodiag.choice.preview.form.option1' },
  { icon: 'COMPOSANT_PNEU', labelKey: 'autodiag.choice.preview.form.option2' },
  { icon: 'COMPOSANT_ROUE', labelKey: 'autodiag.choice.preview.form.option3' },
  { icon: 'COMPOSANT_FREIN', labelKey: 'autodiag.choice.preview.form.option4' },
  {
    icon: 'COMPOSANT_DERAILLEUR',
    labelKey: 'autodiag.choice.preview.form.option5',
  },
];

// min-height (pas height fixe) : à zoom texte 200% (WCAG 1.4.4) ou avec une
// traduction plus longue, les 6 lignes doivent pouvoir grandir au lieu de
// déborder par le haut — l'alignement des deux cartes est garanti par le
// même token.
const Wrap = styled.span`
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-height: ${AUTODIAG.previewHeight}px;
  justify-content: flex-end;
`;

const FormTitle = styled.span`
  display: block;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: ${AUTODIAG.bodyTracking};
  color: ${AUTODIAG.dark};
  margin-bottom: 1px;
`;

const Row = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 1px 7px;
  border: 1px solid ${(p) => (p.$active ? AUTODIAG.dark : AUTODIAG.border)};
  border-radius: 7px;
  background: ${AUTODIAG.white};
  font-size: 11px;
  line-height: 1.3;
  letter-spacing: ${AUTODIAG.bodyTracking};
  color: ${AUTODIAG.dark};
  & > img {
    width: 12px;
    height: 12px;
  }
`;

export default function AutodiagFormPreview() {
  const { t } = useTranslation();
  return (
    <Wrap>
      <FormTitle>{t('autodiag.choice.preview.form.title')}</FormTitle>
      {ROWS.map((row, index) => (
        <Row key={row.icon} $active={index === 0}>
          <img src={iconUrl(row.icon)} alt="" />
          {t(row.labelKey)}
        </Row>
      ))}
    </Wrap>
  );
}
